<template>
    <div>
<!--        <el-select v-model="state" size="mini" @change="chooseStatus" style="margin-right: 9px;width:110px; ">-->
<!--            <el-option v-for="item in stateList" :key="item.key" :label="item.label" :value="item.key"></el-option>-->
<!--        </el-select>-->
        <el-button class="marB10" @click="stateFun(0)" :class="baseerp+'btn'" size="mini">
            {{$t('companyManageMD_defrost')}}
        </el-button>
        <el-button class="marB10" @click="stateFun(-1)" :class="baseerp+'btn'" size="mini">
            {{$t('companyManageMD_freeze')}}
        </el-button>
        <el-button class="marB10" @click="stateFun(-2)" :class="baseerp+'btn'" size="mini">
            {{$t('companyManageMD_account_closure')}}
        </el-button>
        <el-table border  @selection-change="handleSelectionChange" ref="sgtable1" size="mini" :data="tableData" :height="tableHeight" row-key="i_id"
                  :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
            <el-table-column  align="center" :selectable="selectable"  type="selection" width="50px" ></el-table-column>
            <el-table-column type="index" :label="$t('form_serial_number')" width="50"></el-table-column>
            <el-table-column  prop="i_state" :label="$t('form_status')" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
<!--                    <el-select v-model="scope.row.i_state" size="mini" @change="changeFun(scope.row)" style="width:100%; "v-if="canEdit&&scope.row.i_isdefault!=1">-->
<!--                        <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>-->
<!--                    </el-select>-->
<!--                    <el-radio-group v-model="scope.row.i_state" :disabled="!canEdit" @input="changeFun(scope.row)">-->
<!--                        <el-radio  :label="0">解冻</el-radio>-->
<!--                        <el-radio  :label="-1">冻结</el-radio>-->
<!--                        <el-radio  :label="-2">销户</el-radio>-->
<!--                    </el-radio-group>-->
                    <div class="mrA" >{{stateList.find(i=>i.i_id==scope.row.i_state).vc_name}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="i_isdefault"  width="100" show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('companyManageMD_default_account')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.i_isdefault"@input="changeisdefault(scope.row,scope.$index)" :disabled="!canEdit||scope.row.i_state!=0" >
                        <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                        <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    </el-radio-group>
<!--                    <div class="mrA" v-else>{{scope.row.i_state==-1?'否':'是'}}</div>-->
                </template>
            </el-table-column>
            <el-table-column  prop="i_contract_available"  width="100" show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>是否合同使用</span>
                </template>
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.i_contract_available"@input="changeFun(scope.row)" :disabled="!canEdit||scope.row.i_state!=0" >
                        <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                        <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    </el-radio-group>
<!--                    <div class="mrA" v-else>{{scope.row.i_state==-1?'否':'是'}}</div>-->
                </template>
            </el-table-column>
            <el-table-column  prop="i_contract_type"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>合同类型</span>
                </template>
                <template slot-scope="scope" v-if="scope.row.i_contract_available==1">
                    <el-select v-model="scope.row.i_contract_type" size="mini" @change="changeFun(scope.row)" style="width:100%; "v-if="canEdit&&scope.row.i_state==0">
                        <el-option v-for="item in htList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.i_contract_type?htList.find(a=>a.i_id==scope.row.i_contract_type).vc_name:''}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_gsname" :label="$t('form_corporate_name')" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="i_account_type"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>账户类型</span>
                </template>
                <template slot-scope="scope">
                    <el-select v-model="scope.row.i_account_type" size="mini" @change="changeFun(scope.row)" style="width:100%; "v-if="canEdit&&scope.row.i_state==0">
                        <el-option v-for="item in accountTypeList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.i_account_type?accountTypeList.find(a=>a.i_id==scope.row.i_account_type).vc_name:''}}</div>
                </template>
            </el-table-column>

            <el-table-column  prop="i_pid"  show-overflow-tooltip>  <!--总行-->
                <template #header>
                    <span class="red-star">*</span><span>{{$t('companyManageMD_bank_abbreviation')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-select v-model="scope.row.i_pid" size="mini" @change="chooseBank(scope.row,scope.$index)" filterable :remote="true"
                               :remote-method="banksearch" style="width:100%; "v-if="canEdit&&scope.row.i_state==0">
                        <el-option v-for="item in bankList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.vc_bank_sname}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="i_bank_id"  show-overflow-tooltip><!--支行-->
                <template #header>
                    <span class="red-star">*</span><span>{{$t('companyManageMD_full_name_of_bank')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-select v-model="scope.row.i_bank_id" size="mini" @change="zhchooseBank(scope.row,scope.$index)" filterable :remote="true"
                               :remote-method="(val)=>zhbanksearch(val,scope.row,scope.$index)" style="width:100%; "v-if="canEdit&&scope.row.i_state==0">
                        <el-option v-for="item in scope.row.zhbankList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.vc_bank_name}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_bank_account"  show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('companyManageMD_bank_account_number')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-if="canEdit&&scope.row.i_state==0&&scope.row.i_id==0" v-model="scope.row.vc_bank_account" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                    <div class="mrA" v-else>{{scope.row.vc_bank_account}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_bank_endnum" width="100" show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('companyManageMD_the_last_four_digits_of_the_account')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-input v-if="canEdit&&scope.row.i_state==0&&scope.row.i_id==0" @change="changeFun(scope.row)" v-model="scope.row.vc_bank_endnum" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                    <div class="mrA" v-else>{{scope.row.vc_bank_endnum}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="i_currency"  width="100px" show-overflow-tooltip>
                <template #header>
                    <span class="red-star">*</span><span>{{$t('form_currency')}}</span>
                </template>
                <template slot-scope="scope">
                    <el-select v-if="canEdit&&scope.row.i_id==0&&scope.row.i_state==0"  @change="chooseBz(scope.row,scope.$index)" v-model="scope.row.i_currency" size="mini">
                        <el-option v-for="item in bzList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.vc_currency}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="vc_otherbz" :label="$t('companyManageMD_other_currencies')" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-select v-if="canEdit&&scope.row.i_state==0" multiple v-model="scope.row.vc_otherbzList" @change="qtbzChange(scope.row,scope.$index)" size="mini">
                        <el-option v-for="item in bzList&&bzList.filter(bz=>bz.i_id!=scope.row.i_currency)" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                    </el-select>
                    <div class="mrA" v-else>{{scope.row.vc_otherbzname}}</div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('form_operate')" width="40" align="center">
                <template slot="header" slot-scope="scope" v-if="canEdit">
                    <el-button  icon="el-icon-plus"  @click="addRow"   size="mini" v-if="canEdit" type="text" ></el-button>
                    <!--                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>-->
                </template>
                <template slot-scope="scope">
                    <el-button  icon="el-icon-minus" type="text"  v-if="canEdit&&scope.row.i_id==0" @click="deletepz(scope.row,scope.$index)"  size="mini"></el-button>
                    <!--                    <el-button  type="text"  @click="addSg(scope.row,scope.$index)"  size="mini" >编辑</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <div  class="center">
            <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--            <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">禁用</el-button>-->
<!--            <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
            <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">{{$t('button_edit')}}</el-button>
<!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "BankList",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
               tableData:[],
                bankList:[],
                bzList:[],
                zhbankList:[],
                canEdit:false,
                disabled:false,
                stateList:[{i_id:0,vc_name:this.$t('companyManageMD_defrost')},{i_id:-1,vc_name:this.$t('companyManageMD_freeze')},{i_id:-2,vc_name:this.$t('companyManageMD_account_closure')}],
                // state:'',
                bank_search:'',
                zhbank_search:'',
                multipleSelection:[],
                accountTypeList:[{i_id:1,vc_name:'基本户'},{i_id:2,vc_name:'一般户'}],
                htList:[{i_id:1,vc_name:'销售'},{i_id:2,vc_name:'采购'},{i_id:3,vc_name:'全部'}],
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            this.getCompanyBankList()
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            selectable(row){
                if(row.i_id){
                    return true
                }else{
                    return false
                }
            },
            handleSelectionChange(val,row) {
                // console.log(val,row)
                this.multipleSelection = val;
            },
            changeisdefault(row,index){
                row.change='change';
                if(row.i_isdefault==1){
                    for(let i=0;i<this.tableData.length;i++){
                        if(i!==index&&this.tableData[i].i_isdefault==1){
                            this.tableData[i].i_isdefault=0
                            this.tableData[i].change='change'
                            // this.#set(this.tableData[i],'i_isdefault',0)
                        }
                    }
                }
            },
            //延迟搜索
            banksearch(val){
                this.bank_search=val;
                this.getParentBankList()
            },
            //延迟搜索
            zhbanksearch(val,row,index){
                this.zhbank_search=val;
                if(row.i_pid==null){
                    this.$message.warning(this.$t('companyManageMD_please_select_the_head_office_first'))
                }else{
                    this.getSubBankList(row.i_pid,index)
                }
            },
            chooseBank(row,index){
                let val=row,obj=this.bankList.find(b=>val.i_pid==b.i_id);
                // console.log(row,obj,'-----')
                // row.i_pid=obj.i_id;
                row.vc_bank_sname=obj.vc_name;
                row.vc_bank_name='';
                row.i_bank_id=null;
                row.change='change';
                this.getSubBankList(row.i_pid,index)
            },
            zhchooseBank(row,index){
                let val=row,obj=row.zhbankList.find(b=>val.i_bank_id==b.i_id);
                // row.i_pid=obj.i_pid;
                // row.vc_bank_sname=obj.vc_sname;
                row.vc_bank_name=obj.vc_name;
                // row.i_bank_id=obj.i_id;
                row.change='change'
            },
            chooseBz(row,index){
                let val=row,obj=this.bzList.find(b=>val.i_currency==b.i_id);
                row.vc_currency=obj.vc_name;
                row.change='change'

            },
            qtbzChange(row,index){
                // console.log(row,'row')
                // row.vc_otherbz=row.vc_otherbzList.join(',');
                this.tableData.splice(index,1,row)
                this.$set( this.tableData[index],'vc_otherbzList',row.vc_otherbzList)

                row.change='change'
                this.$forceUpdate()
            },
            changeFun(row){
                row.change='change'
            },
            chooseStatus(){
                this.currentPage=1
                this.getCompanyBankList()
            },
            addRow(row,index){
                this.tableData.unshift({
                    i_id:0,
                    vc_gsname:this.data.vc_name,
                    i_gsid:this.data.i_id,
                    i_state:0,
                    i_isdefault:0,
                    i_pid:null,
                    vc_bank_sname:'',
                    vc_bank_name:'',
                    i_bank_id:null,
                    vc_bank_account:null,
                    vc_bank_endnum:null,
                    i_account_type:2,
                    i_contract_type:0,
                    i_contract_available:0,
                })
            },
            deletepz(row,index){
                this.tableData.splice(index,1);
                // if(row.id!=0)this.formData.delgoods.push(row.id);
                // this.getSum(row,index)
            },
            stateFun(type){
                let tableData=JSON.parse(JSON.stringify(this.multipleSelection)),
                    arr=this.multipleSelection.filter(i=>i.i_isdefault==1),
                    typename= this.stateList.find(i=>i.i_id==type).vc_name;
                if(tableData.length==0){
                    this.$message.warning(this.$t('companyManageMD_data_cannot_be_empty'));
                    return
                }
                if(arr.length>0){
                    this.$message.warning(this.$t('companyManageMD_default_account_cannot_change_status'));
                    return
                }
                tableData.map(bank=>{
                    bank.i_state=type
                    // if(bank.i_id==0){
                    // if(bank.i_id==0){
                    //     bank.vc_otherbz_old='';
                    // }else{
                    //     bank.vc_otherbz_old=JSON.parse(JSON.stringify(bank.vc_otherbz)) ;
                    // }
                    // if(bank.vc_otherbzList&&bank.vc_otherbzList.length>0){
                    //     bank.vc_otherbz=bank.vc_otherbzList.join(',')
                    // }else{
                    //     bank.vc_otherbz=''
                    // };
                    // if(!bank.i_pid||!bank.i_bank_id||!bank.vc_bank_account||!bank.vc_bank_endnum){
                    //     cantsave=true
                    // }
                    // delete bank.zhbankList
                    // }else if(bank.i_id==0){
                    //     let A=bank.vc_otherbz.split(','),
                    //         B=bank.vc_otherbzList;
                    //     const setA=new Set(A);
                    //     const setB=new Set(B);
                    //     bank.editBzs=B.filter(x=>!setA.has(x));
                    //     bank.disableBzs=A.filter(x=>!setB.has(x))
                    // }
                });
                this.$confirm('是否'+typename+'这'+tableData.length+'数据',this.$t('tips_prompt'),{
                // this.$confirm(this.$t('companyManageMD_do_you_want_to_these_pieces_of_data',[typename,tableData.length]),this.$t('tips_prompt'),{
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type:"warning"
                }).then(()=>{
                    this.updateCompanyBankState(tableData)
                }).catch(()=>{
                    this.$message.info(this.$t('tips_cancel_operation'))
                })
            },
            save(){
                let tableData=this.tableData.filter(b=>b.change=='change'),
                    cantsave=false;
                if(tableData.length==0){
                    this.$message.warning(this.$t('companyManageMD_no_changes'));

                    return
                }
                let arr=this.tableData.filter(a=>a.i_isdefault==1);
                // console.log(arr)
                if(arr.length!=1){
                    this.$message.warning(this.$t('companyManageMD_there_can_only_be_one_default_account'));
                    return
                }
                let arrt=this.tableData.filter(a=>a.i_account_type==1&&a.i_state==0);
                // console.log(arr)
                if(arrt.length>1){
                    this.$message.warning('只能存在一个基本户');
                    return
                }
                tableData.map(bank=>{
                    // if(bank.i_id==0){
                    if(bank.i_id==0){
                        bank.vc_otherbz_old='';
                    }else{
                        bank.vc_otherbz_old=JSON.parse(JSON.stringify(bank.vc_otherbz)) ;
                    }
                    if(bank.vc_otherbzList&&bank.vc_otherbzList.length>0){
                        bank.vc_otherbz=bank.vc_otherbzList.join(',')
                    }else{
                        bank.vc_otherbz=''
                    };
                    if(!bank.i_pid||!bank.i_bank_id||!bank.vc_bank_account||!bank.vc_bank_endnum||!bank.vc_currency){
                        cantsave=true
                    }
                    delete bank.zhbankList
                    // }else if(bank.i_id==0){
                    //     let A=bank.vc_otherbz.split(','),
                    //         B=bank.vc_otherbzList;
                    //     const setA=new Set(A);
                    //     const setB=new Set(B);
                    //     bank.editBzs=B.filter(x=>!setA.has(x));
                    //     bank.disableBzs=A.filter(x=>!setB.has(x))
                    // }
                });
                if(!cantsave){
                    this.addCompanyBankList(tableData)
                }else{
                    this.$message.warning(this.$t('companyManageMD_must_add_item_must_not_be_empty'))
                }
            },
            editForm(){
                this.canEdit=true;
                this.getParentBankList();
                this.getbzlist();
                for (let i=0;i<this.tableData.length;i++){
                    this.getSubBankList(this.tableData[i].i_pid,i)
                }
            },
            cancel(){
                this.$emit('close')
            },
            //总行
            async getParentBankList(){
                let param={
                    vc_search:this.bank_search,
                    // i_state:0

                };
                let res=await API.getParentBankList(param);
                if ( res.code == 1 ){
                    this.bankList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //支行
            async getSubBankList(i_pid,i){
                let param={
                    vc_search:this.zhbank_search,
                    i_pid:i_pid,
                    // i_state:0
                };
                let res=await API.getSubBankList(param);
                if ( res.code == 1 ){
                    // this.tableData[i].zhbankList=res.data;
                    this.$set(this.tableData[i],'zhbankList',res.data)
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //币种
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //银行列表
            async getCompanyBankList(){
                let param={
                    i_gsid:this.data.i_id,
                };
                let res=await API.getCompanyBankList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.CompanyBankParamList;
                    // if(this.tableData.length>0){
                        this.tableData.map(bank=>{
                            if(bank.vc_otherbz!=''){
                                bank.vc_otherbzList=bank.vc_otherbz.split(',').map(Number)
                            }else{
                                bank.vc_otherbzList=[]
                            }
                        })
                    // }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //银行新增
            async addCompanyBankList(tableData){

                let param={
                    CompanyBankParamList:tableData,
                };
                let res=await API.addCompanyBankList(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.getCompanyBankList()
                    this.$emit('close')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //银行新增
            async updateCompanyBankState(tableData){

                let param={
                    CompanyBankParamList:tableData,
                };
                let res=await API.updateCompanyBankState(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.getCompanyBankList()
                    // this.$emit('close')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    .red-star{
        color: red;
    }
    .el-radio{
        margin-right: 5px !important;
    }
    .el-radio__label{
        font-size: 12px;
    }
    .el-input,.el-select,.el-radio-group{
        width: auto !important;
        margin-left: -10px;
    }

</style>